module.exports = __webpack_public_path__ + "952530306d6ba4a0b225ac870d85458a.png";


//////////////////
// WEBPACK FOOTER
// ../images/logo.png
// module id = 3402
// module chunks = 69